import React, {useRef, useState, useEffect} from "react";
import {PageSnippet} from "./PageViewPage";

declare const AppConfig: any;

const CulturalSensitivityPopup: React.FC<any> = () => {
  const [showCulturalSensitivityPopup, setShowCulturalSensitivityPopup] = useState(false);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const cookieName = AppConfig.cultural_sensitivity_popup_cookie_name || 'cs_popup_dismissed';

  const checkCookieExists = (name: string) => {
    return document.cookie.split(';').some((item) => item.trim().startsWith(name + '='));
  };

  useEffect(() => {
    if (!checkCookieExists(cookieName)) {
      setShowCulturalSensitivityPopup(true);
    }
  }, []);

  useEffect(() => {
    if (showCulturalSensitivityPopup && popupRef && popupRef.current) {
      const popup = popupRef.current;
      if (popup) {
        popup.focus();
      }
    }
  }, [showCulturalSensitivityPopup])

  const handleDismiss = () => {
    const dismissSeconds = AppConfig.cultural_sensitivity_popup_dismiss_seconds || 86400;

    const isSecure = window.location.protocol === 'https:';

    document.cookie = [
      `${cookieName}=1`,
      `max-age=${dismissSeconds}`,
      `path=/`,
      `SameSite=Lax`,
      isSecure ? 'Secure' : ''
    ].filter(s => s.length > 0)
     .join('; ');

    setShowCulturalSensitivityPopup(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Escape' || e.key === 'Enter') {
      handleDismiss();
      return true;
    } else if (e.key === 'Tab') {
      e.preventDefault();
      if (e.target && (e.target as Element).classList.contains('cs-popup')) {
        const button = buttonRef.current;
        if (button) {
          button.focus();
        }
      } else {
        const popup = popupRef.current;
        if (popup) {
          popup.focus();
        }
      }

      return true;
    }

    return false;
  };

  if (showCulturalSensitivityPopup) {
    return (
        <>
          <div className="cs-backdrop" onClick={handleDismiss}></div>
          <div aria-labelledby="cs-popup-title" role="dialog" aria-modal="true" ref={popupRef} tabIndex="0" className="cs-popup" onKeyDown={handleKeyPress}>
            <div className="cs-popup-content">
              <button aria-hidden="true" className="cs-popup-close" onClick={handleDismiss}>
                &#215;
                <span className="sr-only">Close</span>
              </button>

              <div id="cs-popup-title" className="sr-only">Cultural Sensitivity declaration</div>

              <PageSnippet slug="cultural-sensitivity-popup" />

              <br/>

              <button ref={buttonRef} className="qg-btn btn-primary" onClick={handleDismiss}>Close</button>
            </div>
          </div>
        </>
    );
  } else {
    return <></>;
  }
};

export default CulturalSensitivityPopup;
